import React from 'react';
import { Card, CardContent, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
    root: {
        width: '98%',
        opacity: '75%',
        padding: '5px',
        marginLeft: '5px',
        marginRight: '5px',
        paddingBottom: '7px !important',
        background: '#f7f8ff',
    },
    title: {
        fontSize: 12,
        textAlign: 'justify',        
        lineHeight: 'initial',
    },
}));

export default function FooterCard() {
    const classes = useStyles();
    return (        
        <Card className={classes.root} square>
            <CardContent className={classes.root}>            
                <Typography className={classes.title} color="textPrimary">
                    O Pague Fácil é uma ferramenta que disponibiliza, para consulta e pagamento, os débitos vencidos, vincendos e pagos (estes apenas do exercício vigente) em que o usuário figure como “Contribuinte”, “Proprietário”, “Administrador”, “Sócio Administrador”, “Diretor”, “Presidente”, “Tesoureiro” ou “representante legal de pessoa jurídica", conforme os cadastros da SEFAZ, não significando necessariamente que os débitos apresentados são de sua responsabilidade. Caso não tenha mais vínculo jurídico com a pessoa jurídica ou com imóvel correspondente ao débito apresentado, procure a Sefaz para regularização do seu cadastro.
                </Typography>
            </CardContent>
        </Card>
    )
}